import { useHudContext, useHudDates } from "../../hud/shared/playbookHUDInfra"

// Resolves which year the chart should render. A caller-provided `year` always
// wins; otherwise the chart follows the playbook HUD's animated date so it
// stays in sync with the rest of the timeline UI.
export const useLaborMixYear = (yearOverride?: number): number => {
  const { animatedDate } = useHudDates()
  return yearOverride ?? animatedDate.getFullYear()
}
